// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__yYf34","loginTitle":"styles_loginTitle__lOsVw","buttonWrapper":"styles_buttonWrapper__Ov15r","summaryWrapper":"styles_summaryWrapper__1YjMF"};